import * as React from "react";

function IcSystemStatusOkDoneFill16(props) {
  const {
    accentColor: accent = "#0194F3",
    color = "#687176",
    width = 16,
    height = 16,
    title,
    titleId,
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-id="IcSystemStatusOkDoneFill16"
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#clip0_1563_15870)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8ZM12.2071 6.70711C12.5976 6.31658 12.5976 5.68342 12.2071 5.29289C11.8166 4.90237 11.1834 4.90237 10.7929 5.29289L7 9.08579L5.20711 7.29289C4.81658 6.90237 4.18342 6.90237 3.79289 7.29289C3.40237 7.68342 3.40237 8.31658 3.79289 8.70711L6.29289 11.2071C6.68342 11.5976 7.31658 11.5976 7.70711 11.2071L12.2071 6.70711Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1563_15870">
          <rect width={16} height={16} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default IcSystemStatusOkDoneFill16;
